import React, { useCallback } from 'react';
import Modal from 'react-modal';
import useTraineeExerciseHistory from '../../hooks/traineeExerciseHistory';
import ExerciseHistoryList from './ExerciseHistoryList';
import ExerciseHistoryDetail from './ExerciseHistoryDetail';
import ICONS from '../../constants/icons';
import { ModalContent, ModalHeader, ModalTitle, CloseButton, ModalBody } from './components';

const customStyles = {
  overlay: {
    backgroundColor: '#05000066',
    zIndex: 44444445,
  },
  content: {
    background: 'transparent',
    zIndex: 44444446,
    width: '1100px',
    maxWidth: '92%',
    minWidth: '300px',
    height: '85vh',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#001212',
    borderRadius: '16px',
    border: 'none',
    padding: '0',
    bottom: 'auto',
    right: 'auto',
    overflow: 'hidden',
  },
};

const TraineeExerciseHistoryModal = ({ isOpen, closeModal, traineeUid }) => {
  const {
    exerciseHistory,
    historyLoading,
    exerciseDetail,
    detailLoading,
    selectedExercise,
    setSelectedExercise,
    favoriteExercises,
    handleEditHistory,
    handleDeleteHistory,
    handleToggleFavorite,
  } = useTraineeExerciseHistory(isOpen ? traineeUid : null);

  const handleClose = useCallback(() => {
    setSelectedExercise(null);
    closeModal();
  }, [closeModal, setSelectedExercise]);

  const handleBack = useCallback(() => {
    setSelectedExercise(null);
  }, [setSelectedExercise]);

  return (
    <Modal onRequestClose={handleClose} isOpen={!!isOpen} style={customStyles}>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>
            {selectedExercise ? 'Exercise Detail' : 'Exercise History'}
          </ModalTitle>
          <CloseButton src={ICONS.X} alt="close" onClick={handleClose} />
        </ModalHeader>
        <ModalBody>
          {selectedExercise ? (
            <ExerciseHistoryDetail
              exercise={selectedExercise}
              entries={exerciseDetail}
              loading={detailLoading}
              onBack={handleBack}
              onEdit={handleEditHistory}
              onDelete={handleDeleteHistory}
            />
          ) : (
            <ExerciseHistoryList
              exercises={exerciseHistory}
              favoriteExercises={favoriteExercises}
              loading={historyLoading}
              onSelectExercise={setSelectedExercise}
              onToggleFavorite={handleToggleFavorite}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TraineeExerciseHistoryModal;
